import { batch, signal } from "@preact/signals-react"

export const stockShareIsEmpty = signal(false)

export const stockShareSkuDetailsFilters = signal({})

export const resetStockShare = () => batch(() => {
    stockShareIsEmpty.value = false
    stockShareSkuDetailsFilters.value = {}
})